import { BASE_URL } from "@/services/api/base";

export const getContractorsEndpoint = `${BASE_URL}/LoaContractors/Get`;
export const getUpdateContractorEndpoint = `${BASE_URL}/LoaContractors/UpdateContractor`;

export const getAddContractorEndpoint = `${BASE_URL}/LoaContractors/AddSubContractor`;
export const getDeleteContractorEndpoint = `${BASE_URL}/LoaContractors/DeleteSubContractor`;
